module.exports = __webpack_public_path__ + "static/media/DMSans-Regular.5246c7eb.eot";